(function () {
  'use strict';

  var root = document.querySelector('[data-elio-or]');
  var configNode = document.getElementById('elio-omnisend-rate-config');
  if (!root || !configNode) return;

  var config;
  try {
    config = JSON.parse(configNode.textContent || '{}');
  } catch (e) {
    return;
  }

  if (!config.enabled && !config.testMode) return;

  /*
    ELIO exit-rate state is deliberately analytics-neutral.
    We only READ shopper interaction already happening on the page and store
    anonymous browser timestamps/counters. We never emit or re-dispatch Meta,
    GA, Shopify, Omnisend, cart, checkout, or conversion events.
  */
  var ELIGIBLE_KEY = 'elio:exit-rate:eligible:v2';
  var SHOWN_KEY = 'elio:exit-rate:last-shown:v2';
  var SESSION_KEY = 'elio:exit-rate:session:v2';
  var MINI_KEY = 'elio:exit-rate:mini:v1';
  var DISCOUNT_KEY = 'elio_active_discount_code';
  var DISCOUNT_APPLIED_KEY = 'elio:discount:auto-applied:v1';

  var DAY_MS = 24 * 60 * 60 * 1000;
  var RECENT_PROGRESS_MS = 120 * 1000;

  var card = root.querySelector('.elio-or');
  var closeButton = root.querySelector('[data-elio-or-close]');
  var scrim = root.querySelector('[data-elio-or-scrim]');
  var copyButton = root.querySelector('[data-elio-or-copy]');
  var continueButton = root.querySelector('[data-elio-or-continue]');
  var codeNode = root.querySelector('[data-elio-or-code]');
  var copyLabelNode = root.querySelector('[data-elio-or-copy-label]');
  var copiedToast = root.querySelector('[data-elio-or-copied]');
  var confirmedPanel = root.querySelector('[data-elio-or-confirmed]');
  var confirmedInstructionNode = root.querySelector(
    '[data-elio-or-confirmed-instruction]'
  );
  var confirmedCountdown = root.querySelector(
    '[data-elio-or-confirmed-countdown]'
  );
  var confirmedCountdownValue = root.querySelector(
    '[data-elio-or-confirmed-countdown-value]'
  );

  var mini = root.querySelector('[data-elio-or-mini]');
  var miniCopyButton = root.querySelector('[data-elio-or-mini-copy]');
  var miniCloseButton = root.querySelector('[data-elio-or-mini-close]');
  var miniStatusNode = root.querySelector('[data-elio-or-mini-status]');

  var copiedTimeout = null;
  var minimizeTimeout = null;
  var typingTimeout = null;
  var countdownTimeout = null;
  var countdownInterval = null;
  var showTimeout = null;

  function safeLocalGet(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function safeLocalSet(key, value) {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {}
  }

  function safeSessionGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function safeSessionSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (e) {}
  }

  function safeSessionRemove(key) {
    try {
      window.sessionStorage.removeItem(key);
    } catch (e) {}
  }

  function configuredDiscountCode() {
    return String(config.code || '').trim();
  }

  function activateConfiguredDiscount() {
    var code = configuredDiscountCode();
    if (!code) return;

    safeLocalSet(DISCOUNT_KEY, code);

    var appliedMarker = safeSessionGet(DISCOUNT_APPLIED_KEY);
    if (appliedMarker === code) return;

    safeSessionSet(DISCOUNT_APPLIED_KEY, code);

    fetch('/discount/' + encodeURIComponent(code) + '?redirect=/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: {
        Accept: 'application/json'
      }
    }).catch(function () {
      /*
        Do not interrupt signup/copy UX if the background claim fails.
        Existing ELIO checkout routing can still use the stored code.
      */
    });
  }

  function numberValue(value, fallback) {
    var n = Number(value);
    return Number.isFinite(n) ? n : fallback;
  }

  function acceptedFormIds() {
    return String(config.formIds || '')
      .split(',')
      .map(function (value) {
        return value.trim();
      })
      .filter(Boolean);
  }

  function formMatches(detail) {
    var allowed = acceptedFormIds();

    if (!allowed.length) return true;

    var form = detail && detail.form ? detail.form : {};

    var candidates = [
      form.id,
      form.name,
      form.versionID,
      form.versionId
    ]
      .filter(Boolean)
      .map(function (value) {
        return String(value);
      });

    return allowed.some(function (id) {
      return candidates.indexOf(id) !== -1;
    });
  }

  function readSession() {
    var raw = safeSessionGet(SESSION_KEY);
    var state = null;

    if (raw) {
      try {
        state = JSON.parse(raw);
      } catch (e) {
        state = null;
      }
    }

    if (!state || state.v !== 2) {
      state = {
        v: 2,
        startedAt: Date.now(),
        activeMs: 0,
        pageViews: 0,
        pdpViews: 0,
        pdpPaths: [],
        maxScrollPct: 0,
        lastCommercialAt: 0
      };
    }

    return state;
  }

  var session = readSession();

  if (!Array.isArray(session.pdpPaths)) {
    session.pdpPaths = [];
  }

  session.pageViews += 1;

  if (
    /^\/products\//i.test(window.location.pathname) &&
    session.pdpPaths.indexOf(window.location.pathname) === -1
  ) {
    session.pdpPaths.push(window.location.pathname);
    session.pdpViews = session.pdpPaths.length;
  }

  safeSessionSet(SESSION_KEY, JSON.stringify(session));

  var visibleSince =
    document.visibilityState === 'visible' ? Date.now() : 0;

  function persistSession() {
    safeSessionSet(SESSION_KEY, JSON.stringify(session));
  }

  function activeMsNow() {
    return (
      session.activeMs +
      (visibleSince
        ? Math.max(0, Date.now() - visibleSince)
        : 0)
    );
  }

  function flushActiveTime() {
    if (visibleSince) {
      session.activeMs += Math.max(
        0,
        Date.now() - visibleSince
      );
      visibleSince = 0;
    }

    if (document.visibilityState === 'visible') {
      visibleSince = Date.now();
    }

    persistSession();
  }

  function eligibleAt() {
    return numberValue(
      safeLocalGet(ELIGIBLE_KEY),
      0
    );
  }

  function markEligible() {
    safeLocalSet(
      ELIGIBLE_KEY,
      String(Date.now())
    );
  }

  function suppressed() {
    var lastShown = numberValue(
      safeLocalGet(SHOWN_KEY),
      0
    );

    if (!lastShown) return false;

    var days = Math.max(
      1,
      numberValue(
        config.suppressionDays,
        30
      )
    );

    return (
      Date.now() - lastShown <
      days * DAY_MS
    );
  }

  function postSignupGraceComplete() {
    var at = eligibleAt();

    if (!at) return false;

    var grace =
      Math.max(
        0,
        numberValue(
          config.signupGraceSeconds,
          20
        )
      ) * 1000;

    return Date.now() - at >= grace;
  }

  function hasOmnisendSignup() {
    return eligibleAt() > 0;
  }

  function signedUpSessionQualifies() {
    var minSeconds = Math.max(
      0,
      numberValue(
        config.minSessionSeconds,
        45
      )
    );

    var minPdpViews = Math.max(
      1,
      numberValue(
        config.minPdpViews,
        2
      )
    );

    return (
      activeMsNow() >=
        minSeconds * 1000 ||
      session.pdpViews >=
        minPdpViews
    );
  }

  function nonSubscriberSessionQualifies() {
    if (!config.nonSubscriberEnabled) {
      return false;
    }

    var minSeconds = Math.max(
      0,
      numberValue(
        config.nonSubscriberMinSessionSeconds,
        30
      )
    );

    var minPdpViews = Math.max(
      1,
      numberValue(
        config.nonSubscriberMinPdpViews,
        2
      )
    );

    var minScroll = Math.max(
      0,
      Math.min(
        100,
        numberValue(
          config.nonSubscriberMinScrollDepth,
          35
        )
      )
    );

    var enoughTime =
      activeMsNow() >=
      minSeconds * 1000;

    var corroboratingIntent =
      session.pdpViews >=
        minPdpViews ||
      session.maxScrollPct >=
        minScroll;

    return (
      enoughTime &&
      corroboratingIntent
    );
  }

  function meaningfulSession() {
    return hasOmnisendSignup()
      ? signedUpSessionQualifies()
      : nonSubscriberSessionQualifies();
  }

  function cartDrawerOpen() {
    var drawer =
      document.getElementById(
        'shtCartDrawer'
      );

    if (
      drawer &&
      !drawer.hidden &&
      drawer.getAttribute(
        'aria-hidden'
      ) !== 'true'
    ) {
      return true;
    }

    var pairCapture =
      document.querySelector(
        '.elio-pc-modal:not([hidden])'
      );

    if (pairCapture) {
      return true;
    }

    return false;
  }

  function shopperIsTyping() {
    var el =
      document.activeElement;

    if (!el) return false;

    var tag = (
      el.tagName || ''
    ).toLowerCase();

    return (
      tag === 'input' ||
      tag === 'textarea' ||
      tag === 'select' ||
      el.isContentEditable
    );
  }

  function recentlyProgressing() {
    return (
      !!session.lastCommercialAt &&
      Date.now() -
        session.lastCommercialAt <
        RECENT_PROGRESS_MS
    );
  }

  function livePageAllowed() {
    var path = String(
      window.location.pathname ||
        '/'
    ).toLowerCase();

    if (path === '/') {
      return true;
    }

    if (
      path.indexOf(
        '/products/'
      ) === 0
    ) {
      return true;
    }

    if (
      path === '/collections' ||
      path.indexOf(
        '/collections/'
      ) === 0
    ) {
      return true;
    }

    if (
      path === '/search' ||
      path.indexOf(
        '/search/'
      ) === 0
    ) {
      return true;
    }

    return false;
  }

  function canShow() {
    if (config.testMode) {
      return true;
    }

    if (!livePageAllowed()) {
      return false;
    }

    if (!config.enabled) {
      return false;
    }

    if (
      hasOmnisendSignup() &&
      !postSignupGraceComplete()
    ) {
      return false;
    }

    if (
      !hasOmnisendSignup() &&
      !config.nonSubscriberEnabled
    ) {
      return false;
    }

    if (suppressed()) {
      return false;
    }

    if (!meaningfulSession()) {
      return false;
    }

    if (recentlyProgressing()) {
      return false;
    }

    if (cartDrawerOpen()) {
      return false;
    }

    if (shopperIsTyping()) {
      return false;
    }

    return true;
  }

  function updateStickyOffset() {
    if (!card) return;

    var offset = 14;

    if (
      window.innerWidth <= 767 &&
      document.body.classList.contains(
        'elio-sticky-atc-on'
      )
    ) {
      var sticky =
        document.querySelector(
          '.elio-pdp__sticky-atc'
        );

      if (sticky) {
        var rect =
          sticky.getBoundingClientRect();

        if (rect.height > 0) {
          offset += Math.ceil(
            rect.height
          );
        }
      }
    }

    card.style.setProperty(
      '--elio-or-mobile-bottom-offset',
      offset + 'px'
    );

    if (mini) {
      mini.style.setProperty(
        '--elio-or-mobile-bottom-offset',
        offset + 'px'
      );
    }
  }

  function show(reason) {
    if (!canShow()) {
      return false;
    }

    if (!config.testMode) {
      safeLocalSet(
        SHOWN_KEY,
        String(Date.now())
      );
    }

    root.hidden = false;

    root.setAttribute(
      'aria-hidden',
      'false'
    );

    root.setAttribute(
      'data-elio-or-trigger',
      reason || 'exit'
    );

    updateStickyOffset();

    window.clearTimeout(
      showTimeout
    );

    window.requestAnimationFrame(
      function () {
        window.requestAnimationFrame(
          function () {
            root.classList.add(
              'is-visible'
            );
          }
        );
      }
    );

    return true;
  }

  function clearPostCopyTimers() {
    window.clearTimeout(
      minimizeTimeout
    );

    window.clearTimeout(
      typingTimeout
    );

    window.clearTimeout(
      countdownTimeout
    );

    window.clearInterval(
      countdownInterval
    );

    minimizeTimeout = null;
    typingTimeout = null;
    countdownTimeout = null;
    countdownInterval = null;
  }

  function hide() {
    clearPostCopyTimers();

    root.classList.remove(
      'is-visible',
      'is-confirming',
      'is-mini'
    );

    root.setAttribute(
      'aria-hidden',
      'true'
    );

    if (mini) {
      mini.hidden = true;

      mini.setAttribute(
        'aria-hidden',
        'true'
      );
    }

    window.clearTimeout(
      showTimeout
    );

    showTimeout =
      window.setTimeout(
        function () {
          if (
            !root.classList.contains(
              'is-visible'
            ) &&
            !root.classList.contains(
              'is-mini'
            )
          ) {
            root.hidden = true;
          }
        },
        320
      );
  }

  function clearMiniState() {
    safeSessionRemove(
      MINI_KEY
    );
  }

  function miniStateActive() {
    return (
      safeSessionGet(
        MINI_KEY
      ) === '1'
    );
  }

  function showMini() {
    clearPostCopyTimers();

    if (
      !mini ||
      !config.cornerReminderEnabled
    ) {
      hide();
      return;
    }

    if (
      !config.testMode &&
      !livePageAllowed()
    ) {
      hide();
      return;
    }

    safeSessionSet(
      MINI_KEY,
      '1'
    );

    window.clearTimeout(
      minimizeTimeout
    );

    window.clearTimeout(
      showTimeout
    );

    root.hidden = false;

    root.classList.remove(
      'is-visible',
      'is-confirming'
    );

    root.classList.add(
      'is-mini'
    );

    root.setAttribute(
      'aria-hidden',
      'false'
    );

    mini.hidden = false;

    mini.setAttribute(
      'aria-hidden',
      'false'
    );

    if (miniStatusNode) {
      miniStatusNode.textContent =
        config.miniLabel ||
        '10% OFF 2+';
    }

    updateStickyOffset();
  }

  function finishCopiedSequence() {
    if (
      config.cornerReminderEnabled
    ) {
      showMini();
    } else {
      hide();
    }
  }

  function startCopiedCountdown() {
    if (
      !confirmedCountdown ||
      !confirmedCountdownValue
    ) {
      finishCopiedSequence();
      return;
    }

    var remaining = Math.max(
      1,
      Math.round(
        numberValue(
          config.countdownSeconds,
          5
        )
      )
    );

    confirmedCountdownValue.textContent =
      String(remaining);

    confirmedCountdown.hidden =
      false;

    confirmedCountdown.classList.add(
      'is-active'
    );

    window.clearInterval(
      countdownInterval
    );

    countdownInterval =
      window.setInterval(
        function () {
          remaining -= 1;

          confirmedCountdownValue.textContent =
            String(
              Math.max(
                0,
                remaining
              )
            );

          if (remaining <= 0) {
            window.clearInterval(
              countdownInterval
            );

            countdownInterval =
              null;

            minimizeTimeout =
              window.setTimeout(
                finishCopiedSequence,
                320
              );
          }
        },
        1000
      );
  }

  function typeCopiedInstruction(
    done
  ) {
    if (
      !confirmedInstructionNode
    ) {
      done();
      return;
    }

    var message = String(
      config.checkoutInstruction ||
        confirmedInstructionNode.getAttribute(
          'data-message'
        ) ||
        'Paste your code at checkout.'
    );

    confirmedInstructionNode.textContent =
      '';

    confirmedInstructionNode.classList.add(
      'is-typing'
    );

    if (
      window.matchMedia &&
      window
        .matchMedia(
          '(prefers-reduced-motion: reduce)'
        )
        .matches
    ) {
      confirmedInstructionNode.textContent =
        message;

      confirmedInstructionNode.classList.remove(
        'is-typing'
      );

      done();
      return;
    }

    var index = 0;

    function tick() {
      index += 1;

      confirmedInstructionNode.textContent =
        message.slice(
          0,
          index
        );

      if (
        index >=
        message.length
      ) {
        confirmedInstructionNode.classList.remove(
          'is-typing'
        );

        done();
        return;
      }

      typingTimeout =
        window.setTimeout(
          tick,
          34
        );
    }

    typingTimeout =
      window.setTimeout(
        tick,
        260
      );
  }

  function beginCopiedConfirmation() {
    clearPostCopyTimers();

    if (
      config.cornerReminderEnabled
    ) {
      safeSessionSet(
        MINI_KEY,
        '1'
      );
    } else {
      clearMiniState();
    }

    if (confirmedCountdown) {
      confirmedCountdown.hidden =
        true;

      confirmedCountdown.classList.remove(
        'is-active'
      );
    }

    if (
      confirmedCountdownValue
    ) {
      confirmedCountdownValue.textContent =
        String(
          Math.max(
            1,
            Math.round(
              numberValue(
                config.countdownSeconds,
                5
              )
            )
          )
        );
    }

    root.classList.add(
      'is-confirming'
    );

    typeCopiedInstruction(
      function () {
        var lead =
          Math.max(
            0,
            numberValue(
              config.countdownLeadSeconds,
              2
            )
          ) * 1000;

        countdownTimeout =
          window.setTimeout(
            startCopiedCountdown,
            lead
          );
      }
    );
  }

  function omnisendFilledCookiePresent(
    detail
  ) {
    var form =
      detail && detail.form
        ? detail.form
        : {};

    var formId = String(
      form.id || ''
    ).trim();

    if (!formId) {
      return false;
    }

    var cookieName =
      'omnisend-form-' +
      formId +
      '-filled-at=';

    try {
      return document.cookie
        .split(';')
        .some(function (part) {
          return (
            part
              .trim()
              .indexOf(
                cookieName
              ) === 0
          );
        });
    } catch (e) {
      return false;
    }
  }

  function elementIsVisible(
    element
  ) {
    if (
      !element ||
      element.nodeType !== 1
    ) {
      return false;
    }

    if (
      root &&
      root.contains(element)
    ) {
      return false;
    }

    var style;

    try {
      style =
        window.getComputedStyle(
          element
        );
    } catch (e) {
      style = null;
    }

    if (
      style &&
      (
        style.display ===
          'none' ||
        style.visibility ===
          'hidden' ||
        Number(
          style.opacity
        ) === 0
      )
    ) {
      return false;
    }

    var rect =
      element.getBoundingClientRect();

    return (
      rect.width > 0 &&
      rect.height > 0
    );
  }

  function nodeLooksOmnisendOwned(
    node,
    formId
  ) {
    var current = node;
    var levels = 0;

    var wanted = String(
      formId || ''
    ).toLowerCase();

    while (
      current &&
      current !==
        document.body &&
      levels < 10
    ) {
      if (
        current.nodeType === 1
      ) {
        var fingerprint = '';

        try {
          fingerprint +=
            ' ' +
            String(
              current.id || ''
            );

          fingerprint +=
            ' ' +
            String(
              current.className ||
                ''
            );

          Array.prototype.forEach.call(
            current.attributes ||
              [],
            function (attr) {
              fingerprint +=
                ' ' +
                String(
                  attr.name || ''
                ) +
                '=' +
                String(
                  attr.value || ''
                );
            }
          );
        } catch (e) {}

        fingerprint =
          fingerprint.toLowerCase();

        if (
          fingerprint.indexOf(
            'omnisend'
          ) !== -1
        ) {
          return true;
        }

        if (
          wanted &&
          fingerprint.indexOf(
            wanted
          ) !== -1
        ) {
          return true;
        }
      }

      current =
        current.parentElement;

      levels += 1;
    }

    return false;
  }

  function configuredCodeVisibleInOmnisendResult(
    detail
  ) {
    var code =
      configuredDiscountCode();

    if (!code) {
      return false;
    }

    var form =
      detail && detail.form
        ? detail.form
        : {};

    var formId = String(
      form.id || ''
    ).trim();

    var wanted =
      code.toLowerCase();

    var candidates =
      document.querySelectorAll(
        'button, [role="button"], strong, b, code, span, p, div'
      );

    for (
      var i = 0;
      i < candidates.length;
      i += 1
    ) {
      var node =
        candidates[i];

      if (
        !elementIsVisible(
          node
        )
      ) {
        continue;
      }

      if (
        !nodeLooksOmnisendOwned(
          node,
          formId
        )
      ) {
        continue;
      }

      var text = String(
        node.textContent || ''
      )
        .replace(
          /\s+/g,
          ' '
        )
        .trim();

      if (
        !text ||
        text.length > 120
      ) {
        continue;
      }

      var lower =
        text.toLowerCase();

      if (
        lower.indexOf(
          wanted
        ) === -1
      ) {
        continue;
      }

      var context = node;

      for (
        var j = 0;
        j < 5 &&
        context &&
        context !==
          document.body;
        j += 1
      ) {
        var contextText =
          String(
            context.textContent ||
              ''
          )
            .replace(
              /\s+/g,
              ' '
            )
            .trim()
            .toLowerCase();

        if (
          /already\s+(subscribed|signed\s*up)|already\s+on\s+(our|the)\s+(list|email list)/i.test(
            contextText
          )
        ) {
          return false;
        }

        context =
          context.parentElement;
      }

      return true;
    }

    return false;
  }

  function confirmOmnisendSignupSuccess(
    detail
  ) {
    var attempts = 0;

    var delays = [
      0,
      60,
      140,
      280,
      520,
      900,
      1500,
      2400,
      3600,
      5200
    ];

    function check() {
      if (
        omnisendFilledCookiePresent(
          detail
        ) &&
        configuredCodeVisibleInOmnisendResult(
          detail
        )
      ) {
        markEligible();
        activateConfiguredDiscount();
        return;
      }

      attempts += 1;

      if (
        attempts <
        delays.length
      ) {
        window.setTimeout(
          check,
          delays[attempts]
        );
      }
    }

    check();
  }

  function handleOmnisend(
    event
  ) {
    var detail =
      event && event.detail
        ? event.detail
        : {};

    var type =
      detail.type ||
      detail.eventName;

    if (
      type !== 'submit' ||
      !formMatches(detail)
    ) {
      return;
    }

    confirmOmnisendSignupSuccess(
      detail
    );
  }

  function hideMiniForCommercialProgress() {
    if (
      !root.classList.contains(
        'is-mini'
      )
    ) {
      return;
    }

    root.classList.remove(
      'is-mini'
    );

    root.setAttribute(
      'aria-hidden',
      'true'
    );

    if (mini) {
      mini.hidden = true;

      mini.setAttribute(
        'aria-hidden',
        'true'
      );
    }

    root.hidden = true;
  }

  function markCommercialProgress() {
    session.lastCommercialAt =
      Date.now();

    persistSession();

    hideMiniForCommercialProgress();
  }

  function isCommercialTarget(
    target
  ) {
    if (
      !target ||
      !target.closest
    ) {
      return false;
    }

    return !!target.closest(
      '.elio-pdp__atc,' +
        '.elio-pdp__sticky-button,' +
        '[name="add"],' +
        '[name="checkout"],' +
        'a[href*="/checkout"],' +
        'form[action*="/cart/add"] button[type="submit"],' +
        '[data-type="add-to-cart-form"] button[type="submit"]'
    );
  }

  document.addEventListener(
    'click',
    function (event) {
      if (
        isCommercialTarget(
          event.target
        )
      ) {
        markCommercialProgress();
      }
    },
    true
  );

  document.addEventListener(
    'submit',
    function (event) {
      var form =
        event.target;

      if (
        !form ||
        !form.matches
      ) {
        return;
      }

      var action = String(
        form.getAttribute(
          'action'
        ) || ''
      );

      if (
        /\/cart\/add|\/checkout/i.test(
          action
        ) ||
        form.querySelector(
          '[name="checkout"]'
        )
      ) {
        markCommercialProgress();
      }
    },
    true
  );

  if (closeButton) {
    closeButton.addEventListener(
      'click',
      function () {
        clearMiniState();
        hide();
      }
    );
  }

  if (continueButton) {
    continueButton.addEventListener(
      'click',
      hide
    );
  }

  if (miniCloseButton) {
    miniCloseButton.addEventListener(
      'click',
      function () {
        clearMiniState();
        hide();
      }
    );
  }

  document.addEventListener(
    'click',
    function (event) {
      if (
        root.hidden ||
        !root.classList.contains(
          'is-visible'
        )
      ) {
        return;
      }

      if (
        card &&
        card.contains(
          event.target
        )
      ) {
        return;
      }

      hide();
    },
    true
  );

  function fallbackCopy(
    text
  ) {
    var input =
      document.createElement(
        'textarea'
      );

    input.value = text;

    input.setAttribute(
      'readonly',
      ''
    );

    input.setAttribute(
      'aria-hidden',
      'true'
    );

    input.style.position =
      'fixed';

    input.style.left =
      '-9999px';

    input.style.top = '0';

    input.style.opacity =
      '0';

    input.style.pointerEvents =
      'none';

    document.body.appendChild(
      input
    );

    try {
      input.focus({
        preventScroll: true
      });
    } catch (e) {
      input.focus();
    }

    input.select();

    input.setSelectionRange(
      0,
      input.value.length
    );

    var copied = false;

    try {
      copied =
        document.execCommand(
          'copy'
        );
    } catch (e) {
      copied = false;
    }

    document.body.removeChild(
      input
    );

    return copied;
  }

  function copyText(
    text,
    onSuccess,
    onFailure
  ) {
    function fallback() {
      if (
        fallbackCopy(text)
      ) {
        onSuccess();
      } else if (
        onFailure
      ) {
        onFailure();
      }
    }

    if (
      navigator.clipboard &&
      navigator.clipboard.writeText &&
      window.isSecureContext
    ) {
      navigator.clipboard
        .writeText(text)
        .then(onSuccess)
        .catch(fallback);
    } else {
      fallback();
    }
  }

  function fullCopySuccess() {
    activateConfiguredDiscount();

    if (copyLabelNode) {
      copyLabelNode.textContent =
        config.copiedLabel ||
        'CODE COPIED';
    }

    beginCopiedConfirmation();
  }

  function fullCopyFailure() {
    if (!copyLabelNode) {
      return;
    }

    copyLabelNode.textContent =
      'COPY FAILED';

    window.clearTimeout(
      copiedTimeout
    );

    copiedTimeout =
      window.setTimeout(
        function () {
          copyLabelNode.textContent =
            config.copyLabel ||
            'COPY CODE';
        },
        2200
      );
  }

  if (copyButton) {
    copyButton.addEventListener(
      'click',
      function () {
        var code = String(
          config.code ||
            (
              codeNode
                ? codeNode.textContent
                : ''
            ) ||
            ''
        ).trim();

        if (!code) {
          return;
        }

        copyText(
          code,
          fullCopySuccess,
          fullCopyFailure
        );
      }
    );
  }

  if (miniCopyButton) {
    miniCopyButton.addEventListener(
      'click',
      function () {
        var code = String(
          config.code ||
            (
              codeNode
                ? codeNode.textContent
                : ''
            ) ||
            ''
        ).trim();

        if (!code) {
          return;
        }

        copyText(
          code,
          function () {
            activateConfiguredDiscount();

            if (
              miniStatusNode
            ) {
              miniStatusNode.textContent =
                config.copiedLabel ||
                'CODE COPIED';
            }

            window.clearTimeout(
              copiedTimeout
            );

            copiedTimeout =
              window.setTimeout(
                function () {
                  if (
                    miniStatusNode
                  ) {
                    miniStatusNode.textContent =
                      config.miniLabel ||
                      '10% OFF 2+';
                  }
                },
                1800
              );
          },
          function () {
            if (
              miniStatusNode
            ) {
              miniStatusNode.textContent =
                'COPY FAILED';
            }

            window.clearTimeout(
              copiedTimeout
            );

            copiedTimeout =
              window.setTimeout(
                function () {
                  if (
                    miniStatusNode
                  ) {
                    miniStatusNode.textContent =
                      config.miniLabel ||
                      '10% OFF 2+';
                  }
                },
                1800
              );
          }
        );
      }
    );
  }

  document.addEventListener(
    'keydown',
    function (event) {
      if (
        event.key !==
          'Escape' ||
        root.hidden
      ) {
        return;
      }

      if (
        root.classList.contains(
          'is-mini'
        ) ||
        root.classList.contains(
          'is-confirming'
        )
      ) {
        clearMiniState();
      }

      hide();
    }
  );

  document.addEventListener(
    'visibilitychange',
    flushActiveTime
  );

  window.addEventListener(
    'pagehide',
    flushActiveTime
  );

  window.addEventListener(
    'resize',
    updateStickyOffset,
    {
      passive: true
    }
  );

  var bodyObserver =
    new MutationObserver(
      updateStickyOffset
    );

  bodyObserver.observe(
    document.body,
    {
      attributes: true,
      attributeFilter: [
        'class'
      ]
    }
  );

  /*
    DESKTOP EXIT INTENT

    Desktop cursor movement toward browser chrome is noisy.
    The reminder now requires:

    1. At least 60 seconds of active browsing
    AND
    2. Either:
       - 2 distinct PDPs viewed
       OR
       - at least 25% scroll depth

    It also will not fire inside Shopify Theme Editor.
  */
  function desktopExitQualifies() {
    var minSeconds = Math.max(
      60,
      numberValue(
        config.minSessionSeconds,
        45
      )
    );

    var enoughTime =
      activeMsNow() >=
      minSeconds * 1000;

    var comparedProducts =
      session.pdpViews >= 2;

    var meaningfulDepth =
      session.maxScrollPct >= 25;

    return (
      enoughTime &&
      (
        comparedProducts ||
        meaningfulDepth
      )
    );
  }

  document.addEventListener(
    'mouseout',
    function (event) {
      if (
        config.testMode ||
        root.classList.contains(
          'is-visible'
        )
      ) {
        return;
      }

      /*
        Do not trigger while working inside Shopify's
        Theme Editor.
      */
      if (
        window.Shopify &&
        window.Shopify.designMode
      ) {
        return;
      }

      /*
        Desktop / mouse-like pointer only.
      */
      if (
        !window
          .matchMedia(
            '(hover: hover) and (pointer: fine)'
          )
          .matches
      ) {
        return;
      }

      /*
        Ignore movement between page elements.
        This is only a true document exit.
      */
      if (
        event.relatedTarget ||
        event.toElement
      ) {
        return;
      }

      /*
        Only exits through the very top edge qualify.
      */
      if (
        event.clientY > 10
      ) {
        return;
      }

      /*
        Require meaningful browsing before showing.
      */
      if (
        !desktopExitQualifies()
      ) {
        return;
      }

      show(
        'desktop-top-exit'
      );
    }
  );

  /*
    MOBILE EXIT INTENT

    Mobile has no trustworthy cursor-exit signal.
    This observes scroll behavior only.
  */
  var lastY =
    window.scrollY || 0;

  var upwardStartY = 0;
  var upwardStartedAt = 0;
  var scrollTicking = false;

  function handleScrollFrame() {
    scrollTicking = false;

    var y = Math.max(
      0,
      window.scrollY ||
        window.pageYOffset ||
        0
    );

    var doc =
      document.documentElement;

    var scrollable =
      Math.max(
        1,
        (
          doc.scrollHeight ||
          0
        ) -
          window.innerHeight
      );

    var pct =
      Math.max(
        0,
        Math.min(
          100,
          (
            y /
            scrollable
          ) *
            100
        )
      );

    if (
      pct >
      session.maxScrollPct
    ) {
      session.maxScrollPct =
        pct;

      persistSession();
    }

    var isMobileLike =
      window
        .matchMedia(
          '(hover: none), (pointer: coarse)'
        )
        .matches ||
      window.innerWidth <= 767;

    if (
      !config.mobileExitEnabled ||
      !isMobileLike ||
      config.testMode ||
      root.classList.contains(
        'is-visible'
      )
    ) {
      lastY = y;
      return;
    }

    var now = Date.now();

    var delta =
      y - lastY;

    if (delta < -8) {
      if (
        !upwardStartedAt ||
        now -
          upwardStartedAt >
          1800
      ) {
        upwardStartedAt =
          now;

        upwardStartY =
          lastY;
      }

      var reversal =
        upwardStartY - y;

      var requiredReversal =
        Math.min(
          440,
          Math.max(
            260,
            window.innerHeight *
              0.42
          )
        );

      var nearTop =
        y <=
        Math.max(
          110,
          window.innerHeight *
            0.14
        );

      var depthReady =
        session.maxScrollPct >=
        Math.max(
          10,
          numberValue(
            config.mobileMinDepth,
            40
          )
        );

      if (
        depthReady &&
        nearTop &&
        reversal >=
          requiredReversal &&
        now -
          upwardStartedAt <=
          1800
      ) {
        if (
          show(
            'mobile-upward-exit'
          )
        ) {
          upwardStartedAt = 0;
          upwardStartY = 0;
        }
      }
    } else if (
      delta > 8
    ) {
      upwardStartedAt = 0;
      upwardStartY = 0;
    }

    lastY = y;
  }

  window.addEventListener(
    'scroll',
    function () {
      if (scrollTicking) {
        return;
      }

      scrollTicking = true;

      window.requestAnimationFrame(
        handleScrollFrame
      );
    },
    {
      passive: true
    }
  );

  window.addEventListener(
    'omnisendForms',
    handleOmnisend
  );

  if (config.testMode) {
    root.hidden = false;

    root.setAttribute(
      'aria-hidden',
      'false'
    );

    updateStickyOffset();

    window.requestAnimationFrame(
      function () {
        window.requestAnimationFrame(
          function () {
            root.classList.add(
              'is-visible'
            );
          }
        );
      }
    );
  } else if (
    config.enabled &&
    config.cornerReminderEnabled &&
    miniStateActive() &&
    livePageAllowed()
  ) {
    showMini();
  }
})();